import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { SharedNewModule } from 'src/app/shared-new/shared-new.module';
import { UploadStudyModalComponent } from './upload-study-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
@NgModule({
  declarations: [UploadStudyModalComponent],
  imports: [
    CommonModule,
    SharedNewModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    AutocompleteLibModule,
    MatCheckboxModule,
    MatFormFieldModule
  ],
  exports: [UploadStudyModalComponent],
})
export class UploadStudyModalModule {}
